import React from "react";
import Tooltip from "./Tooltip";
import { AvailableIcon, DismissIcon, UnavailableIcon } from "../icons/IconCustom";
import { EStatusResource } from "../../features/resources/services/types/enum";

type Props = {
  status?: EStatusResource;
  className?: string;
  isUseIcon?: boolean;
  tooltipText?: string;
  size?: number;
};

const Status = ({ status, className, isUseIcon = true, tooltipText , size = 20}: Props) => {
  let content = null;
  if (isUseIcon) {
    if (status === EStatusResource.Unavailable) {
      content = <UnavailableIcon size={size} />;
    }
    if (status === EStatusResource.Available) {
      content = <AvailableIcon size={size} />;
    }
    if (status === EStatusResource.Disable) {
      content = <DismissIcon size={size} />;
    }
  } else {
    content = (
      <div
        className={`rounded-full flex items-center justify-center border px-2 ${
          status === EStatusResource.Available
            ? "border-lightGreen bg-softGreen text-darkGreen dark:border-strongGreen dark:text-standardGreen dark:bg-midnightGreen"
            : "border-darkRed bg-softPinkLight text-darkRed dark:bg-midnightRed"
        } ${className}`}
      >
        <p className=" font-semibold">{status === EStatusResource.Available ? "Available" : "Unavailable"}</p>
      </div>
    );
  }
  if (tooltipText) {
    content = (
      <Tooltip message={tooltipText} position="top">
        {content}
      </Tooltip>
    );
  }
  return content;
};

export default Status;
